import { callApi, getCommonHeaders } from '../authConfig';
import CryptoJS from 'crypto-js';

const encryptData = (data, secretKey = 'default-key') => {
  const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
  return { encryptedPayload: ciphertext };
};

export const secureApiCall = async (
  endpoint,
  method = 'post',
  data = {},
  useEncryption = false,
  customHeaders = {}
) => {

  const payload = useEncryption ? encryptData(data) : data;

  const headers = {
    ...getCommonHeaders(),
    ...customHeaders
  };

  try {
    const response = await callApi(endpoint, method, payload, headers);

    //NORMALIZACIÓN PRO DE RESPUESTA
    return {
      success: response?.data?.success ?? true,
      code: response?.data?.code ?? response?.status,
      message: response?.data?.message ?? "",
      data: response?.data?.data ?? response?.data,
      raw: response
    };

  } catch (error) {
    console.error('Error en secureApiCall:', error);

    // MANEJO INTELIGENTE DE ERRORES CON RESPONSE
    if (error?.response) {
      const errorData = error.response.data;

      return {
        success: errorData?.success ?? false,
        code: errorData?.code ?? error.response.status,
        message: errorData?.message ?? "Error del servidor",
        data: errorData?.data ?? null,
        raw: error.response
      };
    }

    //ERROR REAL (network, timeout, etc)
    return {
      success: false,
      code: "500",
      message: "Error de conexión con el servidor",
      data: null
    };
  }
};